import { themeSupportsDarkMode } from './themeSupportsDarkMode';
import { getIsDarkTheme } from 'owa-fabric-theme';
import getTheme from './getTheme';

export default function getFallbackTheme(): string {
    const themeId = getTheme();

    if (!getIsDarkTheme()) {
        // If we're in light-mode, then the fallback theme is just the current theme
        return themeId;
    } else if (themeSupportsDarkMode(themeId)) {
        // If the theme supports dark mode, return the light mode version of the theme
        return themeId;
    } else {
        // For now, we use the base theme as the fallback for all other themes
        // If we support dark mode for a larger subset of themes in the future,
        // we may need to change how we calculate this.
        return 'base';
    }
}
